import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { PageComponentModule, PageSlotModule } from '../../../../cms-structure/page';
import { I18nModule } from '../../../../core/i18n';
import { GenericLinkModule, MegamenuListItemsModule, PrincipalConfigurationDirectiveModule } from '../../../../shared';
import { BadgeModule } from '../../../../shared/components/badge';
import { LoginModule } from '../../../login/login.module';
import { MenuSiteContextModule } from '../../cms-libs/menu-site-context';
import { MyPageMenuModule } from '../../cms-libs/my-page-menu/my-page-menu.module';
import { MobileNavigationLinksComponent } from './mobile-navigation-links.component';

@NgModule({
  declarations: [MobileNavigationLinksComponent],
  imports: [
    NzIconModule,
    CommonModule,
    I18nModule,
    LoginModule,
    MyPageMenuModule,
    MenuSiteContextModule,
    PageSlotModule,
    PageComponentModule.forRoot(),
    NgbNavModule,
    PrincipalConfigurationDirectiveModule,
    GenericLinkModule,
    BadgeModule,
    MegamenuListItemsModule,
  ],
  providers: [],
  exports: [MobileNavigationLinksComponent],
})
export class MobileNavigationLinksModule {}
